module.exports = __webpack_public_path__ + "img/betfury-logo.8557693.svg";